/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Filter_Needs_ReviewInputs */



/**
* | output |
* | --- |
* | "Needs Review" |
*
* @param {Editor_Filter_Needs_ReviewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_filter_needs_review = /** @type {((inputs?: Editor_Filter_Needs_ReviewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Filter_Needs_ReviewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("À réviser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfung erforderlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Da revisionare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Требует проверки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Requiere revisión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("需审核")
	if (locale === "ja") return /** @type {LocalizedString} */ ("要確認")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समीक्षा आवश्यक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Necessita Revisão")
	return /** @type {LocalizedString} */ ("Needs Review")
});